import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, empty } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import {AuthService } from './auth.service'

@Injectable({
  providedIn: 'root'
})


export class HttpErrorinterceptorService implements HttpInterceptor {
  constructor(private router: Router,private authService:AuthService) {
    
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMsg = '';
          if (error.error instanceof ErrorEvent) {
            console.log('this is client side error');
            errorMsg = `Error: ${error.error.message}`;            
          }
          else {
            console.log('this is server side error');
            errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
            if(error.status===401){             
              this.authService.logoutUser();
              return empty();
            }
          }
          console.log('termno aqui');
          console.log(errorMsg);
          return throwError(errorMsg);
        })
      )
  }
}
